// SMM-Casa fork (spike): bypass the folder picker. Use the OPFS root as the
// workspace so /editor and /projects open with no prompt. Chromium only.
import { useEffect, useState } from 'react'
import { setWorkspaceRoot } from '@/infrastructure/storage/workspace-fs/root'
import { bootstrapWorkspace } from '@/infrastructure/storage/workspace-fs/bootstrap'
import { createLogger } from '@/shared/logging/logger'

const logger = createLogger('WorkspaceGate')

export function WorkspaceGate({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(false)
  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const root = await navigator.storage.getDirectory()
        setWorkspaceRoot(root)
        await bootstrapWorkspace(root)
      } catch (error) {
        logger.warn('OPFS workspace init failed', error)
      }
      if (!cancelled) setReady(true)
    })()
    return () => {
      cancelled = true
    }
  }, [])
  if (!ready) return null
  return <>{children}</>
}
